import React from "react";


const DashboardMain = () => {
  

  return (
    <section className="page-content py-3 px-4 bg-lightgray">
      <h1 className="dashboard-title">Dashboard</h1>
    </section>
  );
};

export default DashboardMain;
